import type { WaterRow } from './feedCalculations'

import { readScopedString, readWaterJSON } from './waterStorage'

export const loadDashboardWaterRows = (baseKeys: Iterable<string>): WaterRow[] => {
  const merged: WaterRow[] = []

  for (const baseKey of baseKeys) {
    if (!baseKey) continue
    const trimmed = baseKey.trim()
    if (!trimmed) continue

    const storageKey = trimmed.startsWith('water-') ? trimmed : `water-${trimmed}`
    if (readScopedString(storageKey) === null) continue

    const rows = readWaterJSON<unknown>(storageKey, [])
    if (!Array.isArray(rows) || rows.length === 0) continue

    // We intentionally treat this as best-effort legacy data.
    merged.push(...(rows as WaterRow[]))
  }

  return merged
}
